import { render, staticRenderFns } from "./ViewProjectAbout.vue?vue&type=template&id=02c2c830&scoped=true"
import script from "./ViewProjectAbout.vue?vue&type=script&lang=js"
export * from "./ViewProjectAbout.vue?vue&type=script&lang=js"
import style0 from "./ViewProjectAbout.vue?vue&type=style&index=0&id=02c2c830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2c830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDatePicker,VMenu,VSpacer,VTextField,VTextarea})
